import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const MoreS = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <defs>
          <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="12paz4xqeodb8650d">
            <stop stopColor="currentColor" offset="0%"/>
            <stop stopColor="currentColor" offset="100%"/>
          </linearGradient>
        </defs>
        <g>
          <path d="M8 12.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm0-6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm0-6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"/>
        </g>
      </svg>)} {...props}/>));
export default MoreS;
